import { RSAA } from 'redux-api-middleware';
import { ACCOUNT_CAPABILITIES } from '../../config/';
import { getAccountsPage } from '../../helpers/apiRequestBuilder';
import {
	GET_ACCOUNT_DETAILS_REQUEST,
	GET_ACCOUNT_DETAILS_SUCCESS,
	GET_ACCOUNT_DETAILS_FAILURE,
	DEFAULT_PAGE_SIZE,
	DEFAULT_PAGE,
	GET_ACCOUNT_DETAILS_BY_ID_REQUEST,
	GET_ACCOUNT_DETAILS_BY_ID_SUCCESS,
	GET_ACCOUNT_DETAILS_BY_ID_FAILURE,
} from '../accountPaging/constants';
import { getPaymentType } from '../modes/selectors';
import endpoints from '../../utils/endpoints';

export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS';
export const SET_SELECTED_LCV_ACCOUNT = 'SET_SELECTED_LCV_ACCOUNT';

export const setAccounts = (accounts) => ({
	type: 'SET_ACCOUNTS',
	accounts,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updateAccounts = (accounts) => ({
	type: UPDATE_ACCOUNTS,
	accounts,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setLCVAccounts = (accounts) => ({
	type: 'SET_SELECTED_LCV_ACCOUNT',
	accounts,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const accountServiceRequest = ({ method, uri, x_bpi_version }) => ({
	[RSAA]: {
		endpoint: uri,
		method,
		types: [GET_ACCOUNT_DETAILS_REQUEST, GET_ACCOUNT_DETAILS_SUCCESS, GET_ACCOUNT_DETAILS_FAILURE],
		headers: { 'x-bpi-version': x_bpi_version },
	},
});

export const getAccountUsingSearchParam =
	(searchText = '') =>
	(dispatch, getState) => {
		const state = getState();
		const paymentType = getPaymentType(state);
		const capabilityMapping = ACCOUNT_CAPABILITIES[paymentType];
		const { method, uri, x_bpi_version } = getAccountsPage({
			search: searchText,
			size: DEFAULT_PAGE_SIZE,
			page: DEFAULT_PAGE,
			paymentType: encodeURIComponent(capabilityMapping),
		});
		return dispatch(accountServiceRequest({ method, uri, x_bpi_version }));
	};

export const getAccountDetailsById = (accountId) => {
	const endpoint = endpoints.getAccountDetails.resolve(accountId);
	const { method, x_bpi_version } = endpoints.getAccountDetails;
	return {
		[RSAA]: {
			endpoint,
			method,
			types: [GET_ACCOUNT_DETAILS_BY_ID_REQUEST, GET_ACCOUNT_DETAILS_BY_ID_SUCCESS, GET_ACCOUNT_DETAILS_BY_ID_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};
};
